import React from "react";
import {
	Box,
	Container,
	Grid,
	Typography,
	Card,
	Divider,
	CardContent,
	CardMedia,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SecurityIcon from "@mui/icons-material/Security";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const NewsPage = () => {
	const features = [
		{
			icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
			title: "Market Insights",
			description:
				"Stay ahead with real-time updates on crypto market trends, analysis, and forecasts. Make informed trading decisions with our expert insights.",
		},
		{
			icon: <SecurityIcon sx={{ fontSize: 40, color: "#388e3c" }} />,
			title: "Secure Trading",
			description:
				"Your security is our priority. Enjoy encrypted transactions, two-factor authentication, and a trustworthy trading environment.",
		},
		{
			icon: <PriceCheckIcon sx={{ fontSize: 40, color: "#f57c00" }} />,
			title: "Price Alerts",
			description:
				"Set custom alerts for your favorite cryptocurrencies. Never miss a significant price movement again.",
		},
		{
			icon: <SupportAgentIcon sx={{ fontSize: 40, color: "#fbc02d" }} />,
			title: "24/7 Support",
			description:
				"Our dedicated support team is available around the clock to help you with any issues or questions.",
		},
	];

	const newsArticles = [
		{
			title: "Bitcoin Hits New All-Time High",
			snippet:
				"Bitcoin surged past $70,000 today, driven by institutional investments and positive market sentiment.",
			image:
				"https://images.unsplash.com/photo-1612832024002-5e9672fdd4f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
		},
		{
			title: "Ethereum 2.0 Launch Announced",
			snippet:
				"Ethereum’s long-anticipated upgrade promises increased scalability and security for decentralized applications.",
			image:
				"https://images.unsplash.com/photo-1627570289088-8b4a8f5b2a2a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
		},
		{
			title: "DeFi Projects Gain Popularity",
			snippet:
				"Decentralized finance platforms are seeing rapid growth as users seek alternative financial solutions.",
			image:
				"https://images.unsplash.com/photo-1616680059124-2b1f0f0f7f4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
		},
	];

	return (
		<Container maxWidth="lg" sx={{ py: 4 }}>
			{/* Hero Section */}
			<Box textAlign="center" sx={{ mt: "3rem" }}>
				<Box
					sx={{
						bgcolor: "white",
						color: "black",
						py: 8,
						mt: "4rem",
						textAlign: "center",
						position: "relative",
						mb: "3rem",
					}}>
					<Typography
						variant="h3"
						gutterBottom
						sx={{ fontWeight: "bold", px: "1rem" }}>
						News
					</Typography>
					<Divider
						sx={{
							bgcolor: "black",
							my: "0.5rem",
							width: "5rem",
							marginX: "auto",
						}}
					/>
					<Typography
						variant="h6"
						sx={{
							maxWidth: 600,
							marginX: "auto",
							mb: "5rem",
							color: "#27282A",
							px: "2rem",
						}}>
						Stay informed with the latest developments, market insights, and
						announcements to keep you ahead in the world of cryptocurrency.
					</Typography>
					<div class="custom-shape-divider-bottom-1760313892">
						<svg
							data-name="Layer 1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1200 120"
							preserveAspectRatio="none">
							<path
								d="M649.97 0L550.03 0 599.91 54.12 649.97 0z"
								class="shape-fill"></path>
						</svg>
					</div>
				</Box>
				{/* <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
					Crypto Trading News
				</Typography> */}
				<Typography variant="h6" color="textSecondary">
					Stay updated with the latest trends, analysis, and news in the world
					of cryptocurrency trading.
				</Typography>
			</Box>

			{/* Features Section */}
			<Grid container spacing={4} mb={6}>
				{features.map((feature, index) => (
					<Grid item xs={12} md={3} key={index}>
						<Box
							sx={{
								textAlign: "left",
								p: 2,
								borderRadius: 2,
								boxShadow: 3,
								height: "100%",
								color: "white",
							}}>
							{/* {feature.icon} */}
							<Typography
								variant="h5"
								gutterBottom
								sx={{ mt: 2, fontWeight: "bold", color: "white", ml: "auto" }}>
								{feature.title}
							</Typography>
							<Typography
								variant="body2"
								color="textSecondary"
								textAlign={"left"}
								sx={{ mb: 2, color: "white" }}>
								{feature.description}
							</Typography>
						</Box>
					</Grid>
				))}
			</Grid>

			{/* Latest News Section */}
			{/* <Typography variant="h4" gutterBottom sx={{ mb: 4, fontWeight: "bold" }}>
				Latest News
			</Typography>
			<Grid container spacing={4}>
				{newsArticles.map((article, index) => (
					<Grid item xs={12} md={4} key={index}>
						<Card
							sx={{
								height: "100%",
								display: "flex",
								flexDirection: "column",
								boxShadow: 3,
							}}>
							<CardMedia
								component="img"
								height="180"
								image={article.image}
								alt={article.title}
								sx={{ objectFit: "cover" }}
							/>
							<CardContent>
								<Typography
									variant="h6"
									gutterBottom
									sx={{ fontWeight: "bold" }}>
									{article.title}
								</Typography>
								<Typography variant="body2" color="textSecondary">
									{article.snippet}
								</Typography>
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid> */}
		</Container>
	);
};

export default NewsPage;
